import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

// eslint-disable-next-line no-unused-vars,react/prop-types
const FilteredDiv = ({alignStart, alignEnd, ...otherProps}) => <div {...otherProps} />

const StyledDiv = styled(FilteredDiv)`
  display: inline-flex;
  flex: 1 1;
  align-items: flex-start;
  justify-content: center;
  ${(props) =>
    !!props.alignStart &&
    `
    justify-content: flex-start;
    order: -1;
    flex: 0 1;
  `}
  ${(props) =>
    !!props.alignEnd &&
    `
    justify-content: flex-end;
    order: 1;
  `}
`

const DataTableToolbarSection = ({children, ...otherProps}) => <StyledDiv {...otherProps}>{children}</StyledDiv>

DataTableToolbarSection.propTypes = {
  children: PropTypes.any,
  alignStart: PropTypes.bool,
  alignEnd: PropTypes.bool
}

export {DataTableToolbarSection}
